import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

const StatisticsCards = ({ minigames }) => {
  const activeCount = minigames.filter(m => m.status === 'active').length;
  const inactiveCount = minigames.length - activeCount;
  const averageReward = minigames.length > 0 
    ? Math.round(minigames.reduce((acc, m) => acc + (m.reward || 0), 0) / minigames.length) 
    : 0;

  return (
    <Row className="mb-4">
      <Col md="3">
        <Card className="border-0 shadow-sm">
          <CardBody className="text-center">
            <h2 className="text-success mb-2">{minigames.length}</h2>
            <p className="text-muted mb-0">Tổng Minigame</p>
          </CardBody>
        </Card>
      </Col>
      <Col md="3">
        <Card className="border-0 shadow-sm">
          <CardBody className="text-center">
            <h2 className="text-primary mb-2">{activeCount}</h2>
            <p className="text-muted mb-0">Đang hoạt động</p>
          </CardBody>
        </Card>
      </Col>
      <Col md="3">
        <Card className="border-0 shadow-sm">
          <CardBody className="text-center">
            <h2 className="text-danger mb-2">{inactiveCount}</h2>
            <p className="text-muted mb-0">Đã tắt</p>
          </CardBody>
        </Card>
      </Col>
      <Col md="3">
        <Card className="border-0 shadow-sm">
          <CardBody className="text-center">
            <h2 className="text-warning mb-2">{averageReward}</h2>
            <p className="text-muted mb-0">Phần thưởng TB</p>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default StatisticsCards;

